module.exports = "<!-- <div class=\"layout\">\n    \n    <div class=\"content\">\n      <router-outlet></router-outlet>\n    </div>\n  </div> -->\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/common/base/base.component.html
// module id = ./src/app/common/base/base.component.html
// module chunks = main